import React from "react";
import { Link } from "react-router-dom";
import logo from "../images/POLYGON ORIGINAL LOGO.png";
import logoleaf from "../images/POLYGONLEAF.png";
import {
  FaLinkedin,
  FaFacebook,
  FaTwitter,
  FaYoutube,
  FaInstagram,
  FaGooglePlay,
  FaAppStore,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer
      style={{ backgroundColor: "#F1F3F6" }}
      className="text-white font-sans text-[0.9rem] leading-relaxed"
    >
      {/* Main Footer Content */}
      <div className="px-[30px] md:px-[60px] py-[50px] md:py-[80px]">
        <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-[40px] max-w-[1400px] mx-auto items-center text-center md:text-left">
          {/* Left Section - Logo + Address */}
          <div className="max-w-[280px] w-full flex flex-col items-center md:items-start relative">
            {/* Background Watermark - hidden on mobile */}
            <img
              src={logoleaf}
              alt=""
              aria-hidden="true"
              className="hidden md:block absolute w-[420px] bottom-[-80px] left-[-130px] opacity-15 pointer-events-none select-none"
            />

            {/* Actual Logo */}
            <img
              src={logo}
              alt="Polygon Logo"
              className="w-[140px] md:w-[160px] mb-[20px] block relative z-10"
            />
            <p className="my-[5px] text-[#273941] font-medium text-[14px] relative z-10 md:whitespace-nowrap">
              Level 2, Building 2, No. 46/42, Nawam Mawatha
              <br /> Colombo 02.
            </p>
            <p className="my-[8px] text-[#273941] relative z-10">
              <a
                href="mailto:info@polygon.lk"
                className="no-underline hover:underline font-medium text-[14px]"
              >
                info@polygon.lk
              </a>
            </p>
          </div>

          {/* Short Links */}
          <div className="w-full md:w-auto min-w-[120px]">
            <h4 className="mb-[18px] text-[16px] font-bold text-[#313131]">
              SHORT LINKS
            </h4>
            <ul className="list-none p-0 m-0 space-y-[12px]">
              <li>
                <Link
                  to="/"
                  className="text-[#273941] no-underline text-[14px] font-medium"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-[#273941] no-underline text-[14px] font-medium"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to="/News"
                  className="text-[#273941] no-underline text-[14px] font-medium"
                >
                  Newsletter
                </Link>
              </li>
            </ul>
          </div>

          {/* Solutions */}
          <div className="w-full md:w-auto min-w-[120px]">
            <h4 className="mb-[18px] text-[16px] font-bold text-[#313131]">
              SOLUTIONS
            </h4>
            <ul className="list-none p-0 m-0 space-y-[12px]">
              <li>
                <Link
                  to="/InvestmentFarm"
                  className="text-[#273941] no-underline text-[14px] font-medium"
                >
                  GoVi Capital
                </Link>
              </li>
              <li>
                <Link
                  to="/GoViCare"
                  className="text-[#273941] no-underline text-[14px] font-medium"
                >
                  GoViCare
                </Link>
              </li>
              <li>
                <Link
                  to="/GoViMart"
                  className="text-[#273941] no-underline text-[14px] font-medium"
                >
                  Polygon Marketplace
                </Link>
              </li>
            </ul>
          </div>

          {/* Follow */}
          <div className="w-full md:w-auto flex flex-col items-center md:items-start">
            <h4 className="mb-[18px] text-[16px] font-bold text-[#313131]">
              FOLLOW
            </h4>
            <div className="flex gap-[16px] flex-wrap justify-center md:justify-start">
              <a
                href="/"
                target="_blank"
                rel="noreferrer"
                className="text-[#00E0E0] text-[1.6rem] md:text-[1.3rem] hover:scale-125 inline-block transition-all duration-300"
                aria-label="LinkedIn"
              >
                <FaLinkedin />
              </a>
              <a
                href="/"
                target="_blank"
                rel="noreferrer"
                className="text-[#00E0E0] text-[1.6rem] md:text-[1.3rem] hover:scale-125 inline-block transition-all duration-300"
                aria-label="Facebook"
              >
                <FaFacebook />
              </a>
              <a
                href="/"
                target="_blank"
                rel="noreferrer"
                className="text-[#00E0E0] text-[1.6rem] md:text-[1.3rem] hover:scale-125 inline-block transition-all duration-300"
                aria-label="Twitter"
              >
                <FaTwitter />
              </a>
              <a
                href="/"
                target="_blank"
                rel="noreferrer"
                className="text-[#00E0E0] text-[1.6rem] md:text-[1.3rem] hover:scale-125 inline-block transition-all duration-300"
                aria-label="YouTube"
              >
                <FaYoutube />
              </a>
              <a
                href="/"
                target="_blank"
                rel="noreferrer"
                className="text-[#00E0E0] text-[1.6rem] md:text-[1.3rem] hover:scale-125 inline-block transition-all duration-300"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href="/"
                target="_blank"
                rel="noreferrer"
                className="text-[#00E0E0] text-[1.6rem] md:text-[1.3rem] hover:scale-125 inline-block transition-all duration-300"
                aria-label="Google Play"
              >
                <FaGooglePlay />
              </a>
              <a
                href="/"
                target="_blank"
                rel="noreferrer"
                className="text-[#00E0E0] text-[1.6rem] md:text-[1.3rem] hover:scale-125 inline-block transition-all duration-300"
                aria-label="App Store"
              >
                <FaAppStore />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div
        style={{ backgroundColor: "#091D25" }}
        className="px-[30px] md:px-[60px] py-[20px]"
      >
        <div className="flex flex-col items-center md:flex-row md:justify-between max-w-[1400px] mx-auto gap-[10px] text-center md:text-left">
          <div className="flex flex-col md:flex-row gap-[16px] md:gap-[40px]">
            <Link
              to="/Terms"
              className="text-[#FFFFFF] font-medium no-underline text-[14px] tracking-widest hover:text-[#00B2FF]"
            >
              TERMS & CONDITIONS
            </Link>
            <Link
              to="/Privacy"
              className="text-[#FFFFFF] font-medium no-underline text-[14px] tracking-widest hover:text-[#00B2FF]"
            >
              PRIVACY POLICY
            </Link>
          </div>
          <div className="text-center md:text-right">
            <p className="text-[12px] text-[#A3AEB2] font-medium m-0">
              Copyright &copy; 2026 Polygon Holdings Private Limited
            </p>
            <p className="text-[12px] text-[#A3AEB2] font-medium m-0">
              All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
